export default "__VITE_ASSET__Bkkr_Y3___"